import { Box, Grid, styled, Typography } from "@mui/material";
import AveragePositionChart from "./AveragePositionChart";

const BoxWrapper = styled(Box)(({ theme }) => ({
  marginTop: "20px",
  "& .averagePosition": {
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "20.16px",
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  "& .AverageWrapper": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "& .inputWrapperAverage": {
      "& .MuiFormControl-root": {
        "& label": {
          marginBottom: "0",
          top: "50%",
          transform: "translate(14px, -50%)",
          fontSize: "14px",
          fontWeight: 600,
          lineHeight: "17.64px",
          textAlign: "left",
          color: theme.palette.mode === "dark" ? "#ffffff" : "#2A3547",
          "&.MuiInputLabel-shrink": {
            top: "0",
            transform: "translate(14px, -9px) scale(0.75)",
          },
        },
        "& .MuiAutocomplete-root": {
          "& .MuiInputBase-root": {
            paddingTop: "4.5px",
            paddingBottom: "4.5px",
          },
        },
        "& .MuiFormHelperText-root": {
          position: "absolute",
          top: "40px",
          left: "0",
        },
      },
    },
  },
}));

function TrafficForecast({ rankingData }) {
  return (
    <BoxWrapper>
      <Grid container spacing={2}>
        <Grid item xs="12">
          <Box className="AverageWrapper">
            <Typography className="averagePosition" component="h2">
              Traffic forecast
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <AveragePositionChart rankingData={rankingData} graphType="trafficForecast" />
        </Grid>
      </Grid>
    </BoxWrapper>
  );
}

export default TrafficForecast;
